<template>
    <nav class="header-navigation">
        <ul class="header-navigation__list">
            <HeaderNavigationItem v-for="item in navigation"
                                  :key="item.label"
                                  :is-menu-open="isMenuOpen"
                                  :item="item"
                                  @update-menu-state="onUpdateMenuState"
            />
        </ul>
    </nav>
</template>

<script setup lang="ts">
    import type { HeaderNavigationItemType } from '~/src/widgets/header/ui/HeaderNavigation/types/types'
    import HeaderNavigationItem from '~/src/widgets/header/ui/HeaderNavigation/HeaderNavigationItem.vue'

    defineProps<{
        navigation: HeaderNavigationItemType[]
        isMenuOpen: boolean
    }>()

    const emit = defineEmits<{ (e: 'update-menu-state', value: boolean): void }>()

    const onUpdateMenuState = (value: boolean) => {
        emit('update-menu-state', value)
    }
</script>

<style scoped lang="scss">
    .header-navigation {
        &__list {
            display: flex;
            gap: 40px;
        }
    }
</style>
